import { render, staticRenderFns } from "./SaleDocumentsIdCardCollapse.vue?vue&type=template&id=ab6f14bc&scoped=true&"
import script from "./SaleDocumentsIdCardCollapse.vue?vue&type=script&lang=js&"
export * from "./SaleDocumentsIdCardCollapse.vue?vue&type=script&lang=js&"
import style0 from "./SaleDocumentsIdCardCollapse.vue?vue&type=style&index=0&id=ab6f14bc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6f14bc",
  null
  
)

export default component.exports